import { LiveChatWidget } from "@livechat/widget-react";
import TogetherUserNotAllow from "components/Modal/TogetherUserNotAllow";
import { SITE_VISIT } from "helper/url_helper";
import queryString from "query-string";
import { useEffect, useLayoutEffect, useState } from "react";
import { Helmet } from "react-helmet";
import "react-loading-skeleton/dist/skeleton.css";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { axiosAccount } from "services/api";
import {
  awsConfigWithNoExpiry,
  awsConfigWithYearExpiry,
  get,
  remove,
  set,
} from "services/cookies";
import { facebookCode, googleCode, linkedinCode } from "services/track";
import {
  fetchUserProfile,
  handleIsAuth,
  handleSetToken,
  partnerACTag,
  setChatBoxVisibility,
} from "store/actions";
import { isOrg } from "utils";
import "./assets/scss/style.scss";
import Routes from "./routes";
import axios from "axios";
import { connectMainIo, sendData, socket } from "services/socket";

let remoteInfo = "";

const userNetworkInfo = async () => {
  try {
    let res = await axios.get(
      "https://api.analytics.stuffyoucanuse.org/api/v1/remoteInfo"
    );
    if (res) {
      remoteInfo = res.data.data;
      set("remote_info", remoteInfo);
    }
    console.log(res.data);
  } catch (error) {
    console.error("Error fetching remote info:", error);
  }
};
userNetworkInfo();

socket.on("connect", () => {
  if (
    parseInt(sessionStorage?.getItem("UserId")) !== 0 &&
    !!sessionStorage.getItem("UserId")
  ) {
    let spendTime = performance.now() / 1000;
    sendData(
      sessionStorage?.getItem("UserId"),
      Math.floor(spendTime - parseFloat(sessionStorage.getItem("PrevTime"))),
      remoteInfo
    );
  }
});

const App = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { chatBoxVisibility } = useSelector(state => state.Contact);
  const token = get("token");
  const [isFromTogether, setIsFromTogether] = useState(false);
  const [pathname, setPathname] = useState("");
  const [prevTime, setPrevTime] = useState(0);
  const [loading, setLoading] = useState(true);
  const { user, isAuth } = useSelector(state => state?.Auth);
  const [sourceUrl, setSourceUrl] = useState("");

  const [searchParams] = useSearchParams();
  const partner = searchParams.get("partner");
  /***  Grow Together Related code start ***/

  useEffect(() => {
    /***  This code is for together people not allow ***/
    if (location?.state?.from?.state?.is_from_login_together) {
      setIsFromTogether(true);
    }
  }, [location?.state?.from?.state?.is_from_login_together]);

  const CloseTogetherPopup = () => setIsFromTogether(false);

  /***  Grow Together Related code end ***/

  /***  Analytics Related code start ***/

  useEffect(() => {
    (async () => {
      if (isAuth && user?.user_id) {
        if (pathname !== window.location.pathname) {
          let spendTime = performance.now() / 1000;
          setPrevTime(c => spendTime);
          await sendData(
            user?.user_id,
            Math.floor(spendTime - prevTime),
            remoteInfo
          );
          sessionStorage.setItem("UserId", user?.user_id);
        } else {
          setPathname(v => window.location.pathname);
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth, pathname, user?.user_id]);

  useEffect(() => {
    sessionStorage.setItem("PrevTime", prevTime);
  }, [prevTime]);

  useEffect(() => {
    if (user !== null) {
      user?.user_id && connectMainIo();
    }
  }, [isAuth, user]);

  /***  Analytics Related code end  ***/

  /*** Redirection Related code start ***/

  useEffect(() => {
    const qry = queryString.parse(location.search);
    /*** Wordpress site redirection code-Start ***/
    const { source_page, target, affiliate_source } = qry;

    if (!!source_page) {
      setSourceUrl(source_page);
    } else {
      if (!!target) {
        setSourceUrl(target);
      }
    }
    /*** Wordpress site redirection code-End ***/

    if (!!affiliate_source) {
      set("affiliate_source", affiliate_source);
    }

    if (!!qry?.ref && typeof +qry.ref === "number") {
      set("ref", qry.ref, awsConfigWithYearExpiry);

      if (!!qry?.referrer_url) {
        try {
          (async () => {
            const res = await axiosAccount.post(SITE_VISIT, {
              affiliate_id: +qry.ref || 0,
              url: window.location.href,
              referrer:
                typeof qry.referrer_url === "object"
                  ? qry.referrer_url[0]
                  : qry.referrer_url,
            });
            if (res.status) {
              if (res.data?.data?.affiliate_visit_id) {
                set(
                  "affiliate_visit_id",
                  +res.data.data.affiliate_visit_id,
                  awsConfigWithNoExpiry
                );
              }
            }
          })();
        } catch (err) {}
      }
    }
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (!!!isAuth) {
      if (location.search === "?sign_up=grow-free-trial-kids") {
        window.location.replace(
          `${process.env.REACT_APP_ACCOUNT_SITE_URL}/signup/?sign_up=grow-free-trial-kids&app_id=15&target=free-trial&redirect=https://freetrial.stuffyoucanuse.org/kids?ref=trial`
        );
      }
      if (location.search === "?sign_up=grow-free-trial-students") {
        window.location.replace(
          `${process.env.REACT_APP_ACCOUNT_SITE_URL}/signup/?sign_up=grow-free-trial-students&app_id=15&target=free-trial&redirect=https://freetrial.stuffyoucanuse.org/students?ref=trial`
        );
      }
      if (location.search === "?sign_up=free-trial") {
        window.location.replace(
          `${process.env.REACT_APP_ACCOUNT_SITE_URL}/signup/?sign_up=free-trial&app_id=15&target=free-trial&redirect=https://freetrial.stuffyoucanuse.org/kids?ref=trial`
        );
      }
    }
  }, [isAuth, location]);

  /*** Wordpress site redirection code-start ***/
  useEffect(() => {
    if (!!isAuth && !!sourceUrl) {
      switch (sourceUrl) {
        case "free-trial-students":
          window.location.replace(
            `${process.env.REACT_APP_CURRICULUM_SITE_URL}/students-free-trial`
          );
          break;
        case "free-trial-kids":
          window.location.replace(
            `${process.env.REACT_APP_CURRICULUM_SITE_URL}/kids-free-trial`
          );
          break;
        case "free-trial-groups":
          window.location.replace(
            "https://share.hsforms.com/1q29YjvvtQNmiTNQah8t3XA3q1ax"
          );
          break;
        case "free-trial":
          window.location.replace(
            `${process.env.REACT_APP_FREE_TRIAL_SITE_URL}/kids`
          );
          break;
        case "memory-verse":
          window.location.replace(
            `${process.env.REACT_APP_FREE_TRIAL_SITE_URL}/kids`
          );
          break;
        default:
          window.location.replace(process.env.REACT_APP_REDIRECT_URL);
          break;
      }
    }
  }, [isAuth, sourceUrl]);
  /*** Wordpress site redirection code-end ***/

  useLayoutEffect(() => {
    if (!!token) {
      dispatch(handleIsAuth(true));
      dispatch(handleSetToken(token));
      dispatch(fetchUserProfile());
    }
    setLoading(false);
  }, [dispatch, token]);

  useEffect(() => {
    console.log("partner outside:", partner);
    if (partner && isAuth) {
      console.log("partner inside:", partner);
      dispatch(partnerACTag({ partner: partner }));
      window.location.replace(
        (
          process.env.REACT_APP_CURRICULUM_SITE_URL_2 + `?partner=${partner}`
        )?.replace(/"/g, "")
      );
    }
  }, [dispatch, isAuth, partner]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const handleVisibilityChanged = ({ visibility }) => {
    dispatch(setChatBoxVisibility(visibility));
  };

  const onClose = () => {
    const mainToken = get("mainToken");
    set("token", mainToken);
    remove("mainToken");
    remove("userId");
    remove("site");
    window.location.replace(process.env.REACT_APP_ADMIN_SITE_URL);
  };

  return (
    <>
      <ToastContainer autoClose={3000} />

      {!loading && (
        <>
          {isOrg && (
            <Helmet>
              <script
                async
                src="https://www.googletagmanager.com/gtag/js?id=AW-855676209"
              ></script>

              <script>{googleCode}</script>
              <script>{facebookCode}</script>
              <script>{linkedinCode}</script>
            </Helmet>
          )}

          {!!get("mainToken") && window.location === window.parent.location && (
            <div className="bg-top-bar d-flex align-items-center justify-content-end p-3">
              <button
                className="btn bg-white text-top-bar d-flex align-items-center rounded-pill px-3 frame-close-btn shadow-lg"
                onClick={onClose}
              >
                <i className="fas fa-arrow-left me-2" />
                <span>Back To Dashboard</span>
              </button>
            </div>
          )}
          {!!token ? (
            <LiveChatWidget
              onVisibilityChanged={handleVisibilityChanged}
              visibility={chatBoxVisibility}
              license="8932034"
            />
          ) : null}
          <Routes />
        </>
      )}

      <TogetherUserNotAllow
        isOpen={isFromTogether}
        handleClose={CloseTogetherPopup}
      />
    </>
  );
};

export default App;
